import React, { useState } from "react";
import AttendancePage from "./HR/Attendance/Attendance";
import Employee from "./HR/Employee/Employee";
import Leaves from "./HR/Leaves/Leaves";
import Department from "./HR/Department/Department";
import Designation from "./HR/Designation/Designation";
import Holiday from "./HR/Holiday/Holiday";
import Appreciation from "./HR/Appreciation/Appreciation";
import Action from "./HR/Action/Action";
import LoanAndAdvances from "./HR/LoanAndAdvances/LoanAndAdvances";
import OrganisationalChart from "./HR/OrganisationalChart/OrganisationalChart";
import ShiftRoster from "./HR/ShiftRoster/ShiftRoster";
import RoleToggle from "../components/RoleToggle";

export default function HRPage() {
  const [activeSubTab, setActiveSubTab] = useState("Employee");

  const hrSubTabs = [
    "Employee", "Attendance", "Leaves", "Department", "Designation",
    "Holiday", "Shift Roster", "Appreciation", "Action", "Loan and Advances",
    "Organisational Chart"
  ];

  return (
    <div className="p-4 flex flex-col">
      {/* Header RoleToggle placed right above the background card, outside of it */}
      <div className="flex items-start">
        <RoleToggle
          options={hrSubTabs}
          active={activeSubTab}
          onChange={(label: string) => setActiveSubTab(label)}
          activeClassName="bg-[#000] text-[#FFFFFF] font-bold shadow-sm"
          inactiveClassName="bg-transparent text-[#212121]/70 font-bold"
          containerClassName="inline-flex rounded-t-lg rounded-tr-[20px] bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl transition-all duration-300 py-0.5 px-1 space-x-2 overflow-x-auto hide-scrollbar max-w-full"
        />
      </div>

      {/* Outer Card Background same as Order/Manifest */}
      <div className="relative grid grid-cols-12 gap-6 p-2 bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl transition-all duration-300 w-full rounded-r-3xl rounded-bl-3xl">
        <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />

        <div className="col-span-12 z-10 flex flex-col">
          <section className="min-h-[400px] mt-0">
            {activeSubTab === "Employee" && <Employee />}
            {activeSubTab === "Attendance" && <AttendancePage />}
            {activeSubTab === "Leaves" && <Leaves />}
            {activeSubTab === "Department" && <Department />}
            {activeSubTab === "Designation" && <Designation />}
            {activeSubTab === "Holiday" && <Holiday />}
            {activeSubTab === "Shift Roster" && <ShiftRoster />}
            {activeSubTab === "Appreciation" && <Appreciation />}
            {activeSubTab === "Action" && <Action />}
            {activeSubTab === "Loan and Advances" && <LoanAndAdvances />}
            {activeSubTab === "Organisational Chart" && <OrganisationalChart />}
          </section>
        </div>
      </div>
    </div>
  );
}

